import { PlusCircleIcon } from "lucide-react";

import AddButton from "./AddButton";

export default function Empty() {
  return <>
    <div className='px-9 py-12 flex flex-col items-center gap-4'>
      <div className='text-[14px] twy-text-base-accent'>
        Start Here!
      </div>
      <div className='twy-text-base text-center'>
        Create your first page by clicking the button below.
      </div>
      <AddButton>
        <PlusCircleIcon size={16} />
        New Content Type
      </AddButton>
    </div>
  </>
}
